import HouseholdListContainer from './container/HouseholdListContainer'
// Sync route definition
export default {
  path: '/households',
  component: HouseholdListContainer,
  exact: true,
}

